__webpack_require__.p = "/integrations-webapp-translations/referrals-hub/";